import { render, staticRenderFns } from "./MarksList.vue?vue&type=template&id=54fb2790"
import script from "./MarksList.vue?vue&type=script&lang=js"
export * from "./MarksList.vue?vue&type=script&lang=js"
import style0 from "./MarksList.vue?vue&type=style&index=0&id=54fb2790&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports